import React from "react"
import styled from "styled-components"

export interface TeamImgProps {
  image?: string
  name?: string
  position?: string
}

const TeamImg = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 12px;
  width: fit-content;
  min-width: 0;

  height: 100%;
  background: #1f2434;
  border-radius: 12px;
`

const Image = styled.div`
  img {
    display: block;
    background-color: white;
    object-fit: fill;
    border-radius: 6px;
    width: 190px;
    height: 210px;
    @media (max-width: 900px) and (min-width: 700px) {
      height: auto;
    }

    @media (max-width: 600px) {
      width: 100%;
      height: auto;
    }
  }
`
const PersonDetail = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding-top: 12px;

  @media (max-width: 425px) {
    padding-top: 6px;
    font-size: 0.875rem;
  }
`

const PersonName = styled.div`
  ${(props) => props.theme.typography.heroHeadlineMob}
  display: flex;
  align-items: center;
  color: ${(props) => props.theme.textColor};
  font-size: 1rem;
  line-height: normal;
  font-weight: 600;

  @media (max-width: 425px) {
    font-size: 0.875rem;
  }
`

const PersonPosition = styled.div`
  ${(props) => props.theme.typography.PersonName}
  padding-top: 6px;
  display: flex;
  align-items: center;
  color: ${(props) => props.theme.body};
  text-transform: uppercase;
  line-height: normal;
  @media (max-width: 425px) {
    font-size: 0.875rem;
  }
`

const TeamImgCard: React.FC<TeamImgProps> = ({ image, position, name }) => {
  return (
    <TeamImg>
      <Image>
        <img src={image} width={190} height={210} />
      </Image>
      <PersonDetail>
        <PersonName>{name}</PersonName>
        <PersonPosition>{position}</PersonPosition>
      </PersonDetail>
    </TeamImg>
  )
}

export { TeamImgCard }
